import type { RootState } from 'modules/core/modules/redux';

export const routerSelector = (state: RootState) => state.router;

export const locationSelector = (state: RootState) => state.router.location;
export const selectProp =
    <T>(prop: string) =>
    (_: any, props?: Record<string, unknown>) =>
        props?.[prop] as T;
